/* ==========================================================================
   AULBERY — announcement bar script  (as-announcement-bar.js)
   Moved 1:1 from the inline <script> in sections/custom-announcement-bar.
   Speed, tick, reset window, storage prefix and placeholder text come from
   data-* attributes on the [data-as-annc] root (defaults = old literals).
   ========================================================================== */
(function () {
  'use strict';

  function num(v, fb) {
    var n = parseFloat(v);
    return isNaN(n) ? fb : n;
  }

  function initAnnc(root) {
    var bar = (root || document).querySelector('[data-as-annc]');
    if (!bar || bar.dataset.asInit) return;
    bar.dataset.asInit = '1';

    var cfg = {
      speed: num(bar.dataset.speed, 4000),
      tick: num(bar.dataset.tick, 1000),
      resetMs: num(bar.dataset.resetHours, 24) * 3600000,
      prefix: bar.dataset.storePrefix || 'as-annc-deadline-',
      done: bar.dataset.doneText || '00:00:00',
      slideReset: num(bar.dataset.slideReset, 600)
    };

    /* timer handles live on the root so a section unload can clear them */
    var timers = { interval: null, ticks: [], resets: [] };
    bar.asAnncTimers = timers;

    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.as-annc__msg'));
    var speed = cfg.speed;

    /* countdown blocks — per-session timer, starts on the visitor's first pageview */
    msgs.forEach(function (m) {
      var duration = m.getAttribute('data-duration');
      if (!duration) return;
      var out = m.querySelector('[data-count]');
      if (!out) return;
      var daily = m.getAttribute('data-mode') === 'daily';
      /* key includes duration+mode: changing settings starts a fresh timer */
      var key = cfg.prefix + duration + '-' + (daily ? 'd' : 's');
      var store = daily ? localStorage : sessionStorage;
      var target = 0;
      try { target = parseInt(store.getItem(key) || '0', 10); } catch (e) {}
      /* daily mode: a fresh timer starts again N hours after the last one began */
      if (!target || (daily && target < Date.now() - cfg.resetMs) || (!daily && target < Date.now() - cfg.resetMs)) {
        target = Date.now() + parseInt(duration, 10) * 60000;
        try { store.setItem(key, target); } catch (e) {}
      }
      function tick() {
        var diff = Math.floor((target - Date.now()) / 1000);
        if (diff <= 0) {
          out.textContent = cfg.done;
          if (m.getAttribute('data-hide-expired') === 'true') m.setAttribute('data-expired', 'true');
          return;
        }
        var h = Math.floor(diff / 3600),
            mi = Math.floor((diff % 3600) / 60),
            s = diff % 60;
        out.textContent = [h, mi, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
        timers.ticks.push(setTimeout(tick, cfg.tick));
      }
      tick();
    });

    /* rotation */
    function live() {
      return msgs.filter(function (m) { return m.getAttribute('data-expired') !== 'true'; });
    }
    if (live().length < 2) return;
    var i = 0;
    timers.interval = setInterval(function () {
      var list = live();
      if (list.length < 2) return;
      var cur = list[i % list.length];
      i++;
      var next = list[i % list.length];
      cur.classList.remove('on');
      cur.classList.add('off');
      next.classList.remove('off');
      next.classList.add('on');
      timers.resets.push(setTimeout(function () {
        /* jump back below the bar with no animation — prevents the visible "fall" */
        cur.style.transition = 'none';
        cur.classList.remove('off');
        void cur.offsetWidth; /* force reflow so the jump applies instantly */
        cur.style.transition = '';
      }, cfg.slideReset));
    }, speed);
  }

  /* editor: the section is being replaced — stop its timers */
  function destroyAnnc(root) {
    var bar = (root || document).querySelector('[data-as-annc]');
    if (!bar || !bar.asAnncTimers) return;
    var t = bar.asAnncTimers;
    clearInterval(t.interval);
    t.ticks.forEach(clearTimeout);
    t.resets.forEach(clearTimeout);
    bar.asAnncTimers = null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAnnc(document); });
  } else {
    initAnnc(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAnnc(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAnnc(e.target); });
})();

